<template><finance-document-page document-type="payment" /></template>
<script>
import FinanceDocumentPage from '../components/FinanceDocumentPage'
export default { name: 'ErpFinancePayment', components: { FinanceDocumentPage } }
</script>
